<mat-card class="mb-4" id="efficient-frontier-chart-results">
    <mat-card-header>
        <app-export-control (exportClicked)="exportResultsChart()" [isExporting]="cardExporting['results']">
        </app-export-control>
        <h1>Results<app-info infoIndex="18"></app-info></h1>
    </mat-card-header>
    <mat-card-content>
        <div class="row">
            <div class="col-md-12" style="position:relative;">
                <highcharts-chart *ngIf="loaded" [options]="chartOptions" [constructorType]="chartConstructor"
                    (chartInstance)="setChartInstance($event)"
                    style="width: 100%; height: auto; display: block;"></highcharts-chart>
            </div>
        </div>
    </mat-card-content>
</mat-card>

<mat-card class="mb-4" id="efficient-frontier-chart-results-table">
    <mat-card-content>
        <app-export-control (exportClicked)="exportResultsTable()" [isExporting]="cardExporting['resultsTable']">
        </app-export-control>
        <!-- <div class="row"> -->
        <div class="efficient-toggle">
            <mat-slide-toggle color="primary" [(ngModel)]="showUnconstrainted" name="show-unconstrainted"
                (ngModelChange)="onConstraintToggleChange()">Unconstrained</mat-slide-toggle>
            <mat-slide-toggle class="ms-4" color="primary" [(ngModel)]="showStocks" name="show-stock"
                (ngModelChange)="onStockToggleChange()">Show Equities</mat-slide-toggle>
            <mat-slide-toggle class="ms-4" color="primary" [(ngModel)]="showBenchmark" name="show-benchmark"
                (ngModelChange)="onBenchmarkToggleChange()">Show Benchmark</mat-slide-toggle>

            <mat-slide-toggle class="float-end" color="primary" [(ngModel)]="sliderLocked" name="slider-locked"
                (ngModelChange)="onLockChange()">{{sliderLocked ? 'Unlock' : 'Lock'}} slider</mat-slide-toggle>
        </div>
        <div class="row align-items-center mb-4">
            <div class="col-1 text-end">
                Min
            </div>
            <div class="col-10">
                <div class="slider-container" [hidden]="!sliderLoaded">
                    <mat-slider #slider [max]="sliderMax" [min]="0" [step]="1" [showTickMarks]="true" color="primary"
                        class="w-100" [displayWith]="formatLabel" [disabled]="sliderLocked">
                        <input matSliderThumb [value]="sliderVal" [(ngModel)]="sliderVal" [disabled]="sliderLocked"
                            (valueChange)="onSliderChange($event)">
                    </mat-slider>
                    <!-- Fixed Point Indicator -->
                    <!-- <div *ngIf="fixedPointValue !== null"  -->
                    <div *ngIf="fixedPointTangencyPoint !== null" class="fixed-point-indicator cursor-pointer"
                        [style.left]="getFixedPointPosition()" (click)="onFixedPointClick(fixedPointTangencyPoint)">
                        <div class="fixed-point-label">Tangency PF</div>
                    </div>
                    <div *ngIf="fixedMaxSharpePoint !== null"
                        class="fixed-point-indicator bottom-indicator cursor-pointer"
                        [style.left]="getFixedMaxSharpePointPosition()"
                        (click)="onFixedPointClick(fixedMaxSharpePoint)">
                        <div class="fixed-point-label">Max Sharpe</div>
                    </div>
                </div>
            </div>
            <div class="col-1">
                Max
            </div>
        </div>
        <h1>
            <app-info infoIndex="19"></app-info>
        </h1>
        <table class="table" *ngIf="sliderData.length">
            <thead>
                <tr>
                    <th>Asset</th>
                    <th class="text-end">Expected Return</th>
                    <th class="text-end">Historical Return</th>
                    <th class="text-end">Sharpe Ratio</th>
                    <th class="text-end">Volatility</th>
                    <th class="text-end">Allocation</th>
                    <th class="text-end">Min Weight</th>
                    <th class="text-end">Max Weight</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of sliderData">
                    <td>
                        <span class="underline-on-hover" (click)="onCompanyClick(item.ticker)">
                            {{item.companyName}}
                        </span>
                    </td>
                    <td class="text-end">{{item.expectedReturn*100|number:'1.2-2'}}%</td>
                    <td class="text-end">{{item.historicalReturn*100|number:'1.2-2'}}%</td>
                    <td class="text-end">{{item.sharpeRatio|number:'1.2-2'}}</td>
                    <td class="text-end">{{item.volatility*100|number:'1.2-2'}}%</td>
                    <td class="text-end">{{item.allocation|number:'1.2-2'}}%</td>
                    <td class="text-end">{{item.minWeight ? (item.minWeight|number:'1.2-2') + '%' : ''}}</td>
                    <td class="text-end">{{item.maxWeight ? (item.maxWeight|number:'1.2-2') + '%' : ''}}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td>Portfolio</td>
                    <td class="text-end">{{sliderPortfolioData.y|number:'1.2-2'}}%</td>
                    <td class="text-end"></td>
                    <td class="text-end">{{sliderPortfolioData.sharpeRatio|number:'1.2-2'}}</td>
                    <td class="text-end">{{sliderPortfolioData.x|number:'1.2-2'}}%</td>
                    <td class="text-end">100.00%</td>
                    <td class="text-end"></td>
                    <td class="text-end"></td>
                </tr>
            </tfoot>
        </table>
        <app-next-best-trade [sliderVal]="sliderVal"></app-next-best-trade>
    </mat-card-content>
</mat-card>

<mat-card class="mb-4" *ngIf="areaChartData.length > 0" id="efficient-frontier-chart-transition-map">
    <mat-card-content>
        <app-export-control (exportClicked)="exportTransitionMap()" [isExporting]="cardExporting['transitionMap']">
        </app-export-control>
        <h1>Transition Map<app-info infoIndex="20"></app-info></h1>
        <app-area-chart [chartSeries]="areaChartData" [chartColors]="areaChartColors" [volatilityLine]="volatilityLine"
            [minVolatility]="minVolatility" [maxVolatility]="maxVolatility" [volatilityLineText]="optim"
            [sliderVolatility]="sliderVolatility"></app-area-chart>
    </mat-card-content>
</mat-card>

<div class="row mb-4" *ngIf="sliderData.length">
    <div class="col-md-6 pagebreak">
        <mat-card id="efficient-frontier-chart-summary-weights-donut">
            <mat-card-content>
                <app-export-control (exportClicked)="exportSummaryWeightsDonut()"
                    [isExporting]="cardExporting['summaryWeightsDonut']">
                </app-export-control>
                <section id="summary-weights-donut">
                    <div class="card mb-4 pagebreak">
                        <div class="card-header">
                            <h1>Portfolio Weights<app-info infoIndex="21"></app-info></h1>
                        </div>
                    </div>
                    <div>
                        <app-donut-chart [data]="sliderData" [type]="'allocation'"></app-donut-chart>
                    </div>
                </section>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="col-md-6">
        <mat-card id="efficient-frontier-chart-summary-returns-donut">
            <mat-card-content>
                <app-export-control (exportClicked)="exportSummaryReturnsDonut()"
                    [isExporting]="cardExporting['summaryReturnsDonut']">
                </app-export-control>
                <section id="summary-returns-donut">
                    <div class="card mb-4 pagebreak">
                        <div class="card-header">
                            <h1>Portfolio Returns<app-info infoIndex="22"></app-info></h1>
                        </div>
                    </div>
                    <div>
                        <app-donut-chart [data]="sliderData"></app-donut-chart>
                    </div>
                </section>
            </mat-card-content>
        </mat-card>
    </div>
</div>